import * as action from './issueAction'
import { default as actionType } from './issueActionType'
import { default as reducer } from './issueReducer'

export const ISSUE = {
  action,
  actionType,
  reducer
}
